module.exports = __webpack_public_path__ + "cf2abc3b0265440471cd2c6dd059cfd3.png";